import {createAction} from '@reduxjs/toolkit'

import {ModalCaseType} from '../constant'

/** 배송지 관련 모달 노출 상태 제어 */
export const openDeliveryModal = createAction<ModalCaseType>('deliveryInfo/openDeliveryModal')
export const closeDeliveryModal = createAction('deliveryInfo/closeDeliveryModal')
